import { avatarColor, initials } from '../lib/format';

/** Avatar + name (+ a second line) for tables and lists. */
export function Who({ name, sub }: { name: string; sub?: string }) {
  return (
    <div className="who">
      <span className="av" style={{ background: avatarColor(name) }}>
        {initials(name)}
      </span>
      <div>
        {name}
        {sub && <small>{sub}</small>}
      </div>
    </div>
  );
}
